import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';

import { ChromePicker } from 'react-color';

function CaseSettings() {
   const {  activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
   const [page, setPage] = useState(null);
   const [tab, setTab] =useState('casetypes');
   const [caseType, setcaseType] = useState({id:0});
   const [caseCat, setcaseCat] = useState({id:0,color:'#fff'}); //default to white
   const [ccaction, setCaction] = useState({id:0}); //for cause of action
   const [caseSubcat, setcaseSubcat] = useState({id:0});
   const [motionType, setMotionType] = useState({id:0});
   const [motionClass, setMotionClass] = useState({id:0});
   const [caseStatus, setCaseStatus] = useState({id:0});
    const [filingTypes, setFilingTypes] = useState([]);
   const [caseTypes, setCaseTypes] = useState([]);
   const [caseCats, setCaseCats] = useState([]);
   const [ccactions, setCcactions] = useState([]);
   const [caseSubcats, setCaseSubcats] =useState([])
   const [motionTypes, setMotiontypes]=useState([]);
   const [motionClasses, setMotionClasess] = useState([]);
   const [partyTypes, setPartyTypes] = useState([]);
   const [partyType, setPartyType] = useState({id:0});
   const [caseStatuses, setCaseStatuses] =useState([]);
   const [expiredFlows, setExpiredFlow] =useState([]);
   const [expireFlow, setExpireFlow] = useState({id:0});
   const [customComment, setCustomComment] = useState({id:0});
   const [customComments, setCustomComments] = useState([]);
   const [otherPayItems, setOtherPayItems] = useState([]);
   const [otherPayItem, setOtherPayItem] = useState({id:0});
   const [specialTemplate, setSpecialTemplate] =useState ({id:0});
const [specialTemplates, setSpecialTemplates] =useState ([]);

const [roles, setRoles]= useState([]);
    const [loading, setLoading] = useState(false);
    const [isDialog,setIsDialog] =useState(false);
    const [activeIndex, setActiveIndex] =useState(-1);
    const [err,setErr]=useState('');

     useEffect(() => {
               
       onLoadCaseType();
        onLoadCaseCategory(); 
        onLoadRoles();    
    }, []);

     const onLoadRoles= async()=>{
         //for account registration
         try {
           setLoading(true);
             const resp = await fetch(`${Constants.apiUrl}/profile/roles`, { 
               method: 'GET',
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
               },
             });
             
             const data = await resp.json();
            setRoles(data);
            
           } catch (error) {
            
             console.error(error);
             
           }
     }

    useEffect(() => {
        if(tab=='casetypes' && caseTypes.length==0){
            onLoadCaseType();
        } 
       else if(tab=='casecategrories' && caseCats.length==0){
            onLoadCaseCategory()
        }
        else if(tab=='causeofactions' && ccactions.length==0){
            onLoadCauses()
        }
        else if(tab=='subcategories' && caseSubcats.length==0){
            onLoadSubCats()
        }
        else if(tab=='motiontypes' && motionTypes.length==0){
            onLoadMotiontypes()
        } 
        else if(tab=='motionclass' && motionClasses.length==0){
            onLoadMotionClasses()
        } 
       else if(tab=='partytypes' && partyTypes.length==0){
            onLoadPartyTypes()
        }
       else if(tab=='casestatuses' && caseStatuses.length==0){
            onLoadCaseStatus()
        }
        else if(tab=='expireflow' && expiredFlows.length==0){
            onLoadExpiredFlow()
        }else if(tab=='customcomment' && customComments.length==0){
            onLoadCustomComment()
        }
        else if(tab=='otherpayitem' && otherPayItems.length==0){
            onLoadOtherPayItems()
        }
        else if(tab=='specialtemplate' && specialTemplates.length==0){
            onLoadSpecialTemplate()
        }
         
    }, [tab]);


    const onLoadCaseType=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-types`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 if(data.code==0){
                    setCaseTypes(data.list);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
    const onLoadCaseCategory=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-categories`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 if(data.code==0){
                    setCaseCats(data.list);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
    const onLoadCauses=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/cause-of-actions`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 if(data.code==0){
                    setCcactions(data.list);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
    const onLoadSubCats=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-sub-categories`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                if(data.code==0){
                setCaseSubcats(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
    const onLoadMotiontypes=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/motion-types`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                setMotiontypes(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
    const onLoadMotionClasses=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/motion-class`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                setMotionClasess(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
    const onLoadPartyTypes=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/party-types`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                setPartyTypes(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
    const onLoadCaseStatus=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-statuses`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                setCaseStatuses(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
const onLoadExpiredFlow=async()=>{
        try {
            setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-expireflow`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                setExpiredFlow(data.list);
                }else if(data.code==-10){
                setIsExpired(true)
                }
            
            
            } catch (error) {
                setLoading(false);
                console.error(error);
                
            }
    }
    const onCaseTypeChange = (e) => {
    setcaseType({...caseType, [e.target.name]: e.target.value})   
    }
    const onCaseCatChange = (e) => {
    setcaseCat({...caseCat, [e.target.name]: e.target.value})   
    }
    const onCauseChange = (e) => {
    setCaction({...ccaction, [e.target.name]: e.target.value})   
    }
const onSubcatChange = (e) => {
    setcaseSubcat({...caseSubcat, [e.target.name]: e.target.value})   
    }
  const onMotionTypeChange = (e) => {
    setMotionType({...motionType, [e.target.name]: e.target.value})   
    }  
    const onMotionClassChange = (e) => {
    setMotionClass({...motionClass, [e.target.name]: e.target.value})   
    }  
     const onCaseStatusChange = (e) => {
    setCaseStatus({...caseStatus, [e.target.name]: e.target.value})   
    }
 const onExpireFlowChange = (e) => {
    setExpireFlow({...expireFlow, [e.target.name]: e.target.value})   
    }
     const onPartyTypeChange = (e) => {
    setPartyType({...partyType, [e.target.name]: e.target.value})   
    }
const onCustomCommentChange = (e) => {
    const { name, value } = e.target;
    setCustomComment(prev => ({
        ...prev,
        [name]: value === "" ? null : value   // convert empty string to null
    }));  
    }

    const onOtherPayItemChange = (e) => {
    const { name, value } = e.target;
    setOtherPayItem(prev => ({
        ...prev,
        [name]: value === "" ? null : value   // convert empty string to null
    }));  
    }
    const onSpecialTemplateChange = (e) => {
    const { name, value } = e.target;
    setSpecialTemplate(prev => ({
        ...prev,
        [name]: value === "" ? null : value   // convert empty string to null
    }));  
    }
    const onColorChange = (colorResult) => {
    setcaseCat({...caseCat,colour: colorResult.hex});
    };
   
    const onAdd=()=>{
        setIsDialog(true);
        
    }

    const onEdit=(obj,index)=>{
        setErr('');
        setActiveIndex(index)
        setIsDialog(true);
       if(tab=='casetypes'){
            setcaseType(obj)
        } 
       else if(tab=='casecategrories'){
        console.log(obj);
            setcaseCat(obj)
        }
        else if(tab=='causeofactions'){
            setCaction(obj);
        }
        else if(tab=='subcategories'){
            console.log(obj);
            setcaseSubcat(obj)
        }
        else if(tab=='motiontypes'){
            setMotionType(obj)
        } 
        else if(tab=='motionclass'){
            setMotionClass(obj)
        } 
       else if(tab=='partytypes'){
            setPartyType(obj)
        }
       else if(tab=='casestatuses'){
        
            setCaseStatus(obj)
        }
        else if(tab=='expireflow'){
        
            setExpireFlow(obj)
        }else if(tab=='customcomment'){
        
            setCustomComment(obj)
        }
        else if(tab=='otherpayitem'){
            setOtherPayItem(obj)
        }
        else if(tab=='specialtemplate'){
            setSpecialTemplate(obj)
        }
    }
    
    const onClose=()=>{
        setIsDialog(false);
        setActiveIndex(-1);
         if(tab=='casetypes'){
            setcaseType({id:0})
        } 
       else if(tab=='casecategrories'){
            setcaseCat({id:0})
        }
        else if(tab=='causeofactions'){
            setCaction({id:0});
        }
        else if(tab=='subcategories'){
            setcaseSubcat({id:0})
        }
        else if(tab=='motiontypes'){
            setMotionType({id:0})
        } 
        else if(tab=='motionclass'){
            setMotionClass({id:0})
        } 
       else if(tab=='partytypes'){
            setPartyType({id:0})
        }
       else if(tab=='casestatuses'){
            setCaseStatus({id:0})
        }
        else if(tab=='expireflow'){
            setExpireFlow({id:0})
        }else if(tab=='customcomment'){
            setCustomComment({id:0})
        }else if(tab=='otherpayitem'){
            setOtherPayItem({id:0})
        }else if(tab=='specialtemplate'){
            setSpecialTemplate({id:0})
        }

    }

    const onSave=async(e)=>{
        e.preventDefault();
       var path='';
       var obj=null;
       console.log('in here');
       if(tab=='casetypes' ){
            path='/setup/case-setting/case-type';
            obj={...caseType};
        } 
       else if(tab=='casecategrories'){
            path='/setup/case-setting/case-category';
            obj={...caseCat};
        }
        else if(tab=='causeofactions'){
            path='/setup/case-setting/cause-of-action';
            obj={...ccaction};
        }
        else if(tab=='subcategories' ){
            path='/setup/case-setting/case-sub-category';
            obj={...caseSubcat};
        }
        else if(tab=='motiontypes' ){
            path='/setup/case-setting/motion-type';
            obj={...motionType};
        } 
        else if(tab=='motionclass' ){
             path='/setup/case-setting/motion-classification';
             obj={...motionClass};
        } 
       else if(tab=='partytypes'){
            path='/setup/case-setting/party-type';
            obj={...partyType};
        }
       else if(tab=='casestatuses'){
            path='/setup/case-setting/case-status';
            obj={...caseStatus};
          
        }
        else if(tab=='expireflow'){
            path='/setup/case-setting/case-expireflow';
            obj={...expireFlow};
          
        }
        else if(tab=='customcomment'){
            path='/setup/custom-comment-admin';
            obj={...customComment};
          
        }
      else if(tab=='otherpayitem'){
            path='/setup/otherpayitems';
            obj={...otherPayItem};
          
        }
        else if(tab=='specialtemplate'){
            path='/setup/specialtemplate';
            obj={...specialTemplate};
          
        }
         setLoading(true)
                 try {
                   
                   const url=`${Constants.apiUrl}${path}`;
                   const resp = await fetch(url, {
                     method: 'POST',
                     body:JSON.stringify(obj) ,
                     headers: {
                       'Content-Type': 'application/json, text/plain',
                       Authorization: `Bearer ${token}`,
                     },
                   });
                   
                   const data = await resp.json();
                   setLoading(false);
                   if(data.code==0){
                    setAlert({open:true, title:'Setting',subtitle:'Settings saved successfully'})
                        onDefault(data.id);
                   }
                   else if(data.code==-10){
                         setIsExpired(true);
                     }else{
                       setErr(data.status);
                     }
                //   setFlow({pos:6,code:"congrat"})
                   
                   
                 } catch (error) {
                   setLoading(false);
                   console.error(error);
                   
                  // onMove();
                 }

    }

    const onDefault=(id)=>{
        setErr('');
          setIsDialog(false);
        if(tab=='casetypes'){
            onLoadCaseType();
            setcaseType({id:0})
        } 
       else if(tab=='casecategrories'){
            onLoadCaseCategory()
            setcaseCat({id:0})
        }
        else if(tab=='causeofactions'){
            onLoadCauses();
            setCaction({id:0});
        }
        else if(tab=='subcategories'){
            onLoadSubCats()
            setcaseSubcat({id:0})
        }
        else if(tab=='motiontypes'){
            onLoadMotiontypes()
            setMotionType({id:0})
        } 
        else if(tab=='motionclass'){
            onLoadMotionClasses()
            setMotionClass({id:0})
        } 
       else if(tab=='partytypes'){
            onLoadPartyTypes()
            setPartyType({id:0})
        }
       else if(tab=='casestatuses'){
            onLoadCaseStatus()
            setCaseStatus({id:0})
        }
       else if(tab=='expireflow'){
            onLoadExpiredFlow()
            setExpireFlow({id:0})
        }else if(tab=='customcomment'){
            onLoadCustomComment()
            setCustomComment({id:0})
        }
        else if(tab=='otherpayitem'){
            onLoadOtherPayItems()
            setOtherPayItem({id:0})
        }
        else if(tab=='specialtemplate'){
            onLoadSpecialTemplate()
            setSpecialTemplate({id:0})
        }

    }

    const onLoadCustomComment=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/custom-comment-admin`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 if(data.code==0){
                    setCustomComments(data.list);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
const onLoadOtherPayItems=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/otherpayitems`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 if(data.code==0){
                    setOtherPayItems(data.opayitem);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
const onLoadSpecialTemplate=async()=>{
          try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/setup/specialtemplates`, { 
                   method: 'GET',
                   headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${token}`,
                   },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 if(data.code==0){
                    setSpecialTemplates(data.items);
                 }else if(data.code==-10){
                    setIsExpired(true)
                 }
               
                
               } catch (error) {
                 setLoading(false);
                 console.error(error);
                 
               }
    }
  return (
    <div>
     <div  className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <JisTabButton code="casetypes" isActive={tab=='casetypes'}  title="Case Types" data={page} isRoleBased={false}  onClick={()=> setTab('casetypes')}/>
          <JisTabButton code="casecategrories" isActive={tab=='casecategrories'}  title="Case Categrories" data={page} isRoleBased={false}  onClick={()=> setTab('casecategrories')}/>
          <JisTabButton code="causeofactions" isActive={tab=='causeofactions'}  title="Cause of Actions" data={page} isRoleBased={false}  onClick={()=> setTab('causeofactions')}/>
          <JisTabButton code="subcategories" isActive={tab=='subcategories'}  title="Sub Category" data={page} isRoleBased={false}  onClick={()=> setTab('subcategories')}/>
          <JisTabButton code="motiontypes" isActive={tab=='motiontypes'}  title="Motion Type" data={page} isRoleBased={false}  onClick={()=> setTab('motiontypes')}/>
          <JisTabButton code="motionclass" isActive={tab=='motionclass'}  title="Motion Classification" data={page} isRoleBased={false}  onClick={()=> setTab('motionclass')}/>
          <JisTabButton code="partytypes" isActive={tab=='partytypes'}  title="Party Type" data={page} isRoleBased={false}  onClick={()=> setTab('partytypes')}/>  
          <JisTabButton code="casestatuses" isActive={tab=='casestatuses'}  title="Case status" data={page} isRoleBased={false}  onClick={()=> setTab('casestatuses')}/> 
          <JisTabButton code="expireflow" isActive={tab=='expireflow'}  title="Flow Expire" data={page} isRoleBased={false}  onClick={()=> setTab('expireflow')}/> 
          <JisTabButton code="customcomment" isActive={tab=='customcomment'}  title="Custom Comment" data={page} isRoleBased={false}  onClick={()=> setTab('customcomment')}/> 
          <JisTabButton code="otherpayitem" isActive={tab=='otherpayitem'}  title="Other Pay Items" data={page} isRoleBased={false}  onClick={()=> setTab('otherpayitem')}/> 
          <JisTabButton code="specialtemplate" isActive={tab=='specialtemplate'}  title="Special Template" data={page} isRoleBased={false}  onClick={()=> setTab('specialtemplate')}/>   


        </div>
      {tab=='casetypes' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>New Case Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Case Types</span><span className='total'>{caseTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { caseTypes.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.caseType1}</td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton  variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
       {tab=='casecategrories' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Case Category</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Case Categories</span><span className='total'>{caseCats?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>CaseType</th>
                        <th>Color</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                   { caseCats.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.categoryTitle}</td>
                        <td>{Constants.getItemById(caseTypes,g.caseTypeId)?.caseType1}
                            </td>
                        <td style={{textAlign:'center', display:'flex', justifyContent:'space-between'}}><span>{g.colour}</span> <div style={{width:50,height:50,backgroundColor:g.colour}}></div></td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
       {tab=='causeofactions' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Cause of Action</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Cause of Actions</span><span className='total'>{ccactions?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Case Category</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { ccactions.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>{g.caseCatId==null?'All Categories': Constants.getItemById(caseCats,g.caseCatId)?.categoryTitle}</td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 

       {tab=='subcategories' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Sub Category</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Sub Categories</span><span className='total'>{caseSubcats?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                         <th>SN</th>
                         <th>Code</th>
                         <th>Description</th>
                         <th>Case Category</th>
                         
                         <th>Last Count</th>
                         <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { caseSubcats.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>{g.description}</td>
                        <td>{Constants.getItemById(caseCats,g.caseCategoryId)?.categoryTitle }</td>
                        
                        <td>{g.incrNum}</td>
                         <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
       {tab=='motiontypes' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Motion Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Motion Types</span><span className='total'>{motionTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Filing Type</th>
                 {/*        <th>Status</th> */}
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { motionTypes.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>
                            {Constants.getItemById(frequentData?.filingtypes,g.filingTypeId)?.title}</td>
                      {/*   <td>{g.isActive?'Active':'Inactive'}</td> */}
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
       {tab=='motionclass' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Motion Classification</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Motion Classifications</span><span className='total'>{motionClasses?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Filing Type</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { motionClasses.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>
                            {Constants.getItemById(frequentData?.filingtypes,g.filingTypeId)?.title}
                        </td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
        {tab=='partytypes' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add Party Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Party Types</span><span className='total'>{partyTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Is Lead</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { partyTypes?.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>{g.isLead?'Lead':'Not Lead'}</td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 
        {tab=='casestatuses' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add Case Status</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Party Types</span><span className='total'>{partyTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Filing Type</th>
                        <th>Unique No</th>
                        <th>SLA Days</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { caseStatuses.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.ttile}</td>
                        <td>{g.description}</td>
                        <td>{Constants.getItemById(frequentData?.filingtypes,g.filingTypeId)?.title}</td>
                        <td>{g.id}</td>
                        <td>{g.slaDuration}</td>
                        <td>{true?'Active':'Inactive'}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 
        {tab=='expireflow' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Expired Flow</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Expired Flow</span><span className='total'>{expiredFlows?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Action</th>
                        <th>Description</th>
                        <th>Expire Day</th>
                        <th>Expire Hr</th>
                        <th>Expire Min</th>
                        <th>Reminder Day</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { expiredFlows.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.action}</td>
                        <td>{g.title}</td>
                        <td>{g.expireDay}</td>
                        <td>{g.expireHr}</td>
                        <td>{g.expireMin}</td>
                        <td>{g.reminderDay}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 
        {tab=='customcomment' && <div className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add Custom Comment</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Custom Comment</span><span className='total'>{customComments?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Comment</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { customComments?.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.comment}</td>
                        <td>{g.roleName}</td>
                        <td>{true?'Active':'Inactive'}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
            </div>}
            {tab=='otherpayitem' && <div className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add Other Payment Item</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Other Payment Items</span><span className='total'>{otherPayItems?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Code</th>
                        <th>Group</th>
                        <th>Title</th>
                        <th>Fee</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                   { otherPayItems?.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.code}</td>
                        <td>{g.groupCode}</td>
                        <td>{g.title}</td>
                        <td>{g.fee}</td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
            </div>}
            {tab=='specialtemplate' && <div className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add Special Template</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Special Templates</span><span className='total'>{specialTemplates?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                         <th>Template Id</th>
                        <th>Code</th>
                       <th></th>
                       
                    </tr>
                </thead>
                <tbody>
                   { specialTemplates?.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                         <td>{g.templateId}</td>
                        <td>{g.code}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
            </div>}
     </div>
      <BackLoader open={loading} />
     <div>
      {isDialog && tab=='casetypes' &&  <JisDialogForm title="Case Type" onClose={onClose}>
           <form onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='The Case Type Title'
                    name="caseType1"
                    value={caseType.caseType1}
                    onChange={onCaseTypeChange}
                    required={true}
                  />
                </div>
            </div>
            <div  className="input-group">
                <label> Fee</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Fee'
                    name="fee"
                    value={caseType.fee}
                    onChange={onCaseTypeChange}
                    required={true}
                  />
                </div>
            </div>
            <JisCheckbox value={caseType.isActive} label="Active" onChange={(e)=>setcaseType({...caseType,isActive:e})} />
            <div><JisButton type='submit'>{caseType.id==0?'Save':'Update'}</JisButton></div>
            {err!='' && <div className='error'>{err}</div>}
           </form>
            
        </JisDialogForm>} 
      {isDialog && tab=='casecategrories' && <JisDialogForm title="Case Category" onClose={onClose} >
            <form onSubmit={onSave}>
                <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='The Case Type Title'
                    name="categoryTitle"
                    value={caseCat.categoryTitle}
                    onChange={onCaseCatChange}
                    required={true}
                  />
                </div>
            </div>
            <div className="select-group">
                <label> Case Type <span className="required">*</span> </label>
                <select name="caseTypeId" value={caseCat.caseTypeId} required={true} onChange={onCaseCatChange} >
                    <option value="">Select </option>
                    {caseTypes.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.caseType1}
                    </option>
                    ))}
                </select>
                </div> 
            <div>
                 <ChromePicker color={caseCat.colour??'#fff'} onChange={onColorChange} />
            </div>
            <JisCheckbox value={caseCat.isActive} label="Active" onChange={(e)=>setcaseCat({...caseCat,isActive:e})} />
            <div><JisButton type='submit'>{caseCat.id==0?'Save':'Update'}</JisButton></div>   
            </form>
        </JisDialogForm>}  
       {isDialog && tab=='causeofactions' && <JisDialogForm title="Cause of Action" onClose={onClose}>
            <form onSubmit={onSave}>
                <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='title'
                    name="title"
                    value={ccaction.title}
                    onChange={onCauseChange}
                    required={true}
                  />
                </div>
            </div>
                <div className="select-group">
                <label> Case Catogory <span className="required">*</span> </label>
                <select name="caseCatId" value={ccaction.caseCatId}  onChange={onCauseChange} >
                    <option value=''>All Category </option>
                    {caseCats.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.categoryTitle}
                    </option>
                    ))}
                </select>
                </div>
                 <JisCheckbox value={ccaction.isActive} label="Active" onChange={(e)=>setCaction({...ccaction,isActive:e})} />
            <div><JisButton type='submit'>{ccaction.id==0?'Save':'Update'}</JisButton></div>  
            </form>
        </JisDialogForm>} 
       {isDialog && tab=='subcategories' && <JisDialogForm title="Sub Category" onClose={onClose}>
        <form  onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                <input
                    placeholder='Title'
                    name="title"
                    value={caseSubcat.title}
                    onChange={onSubcatChange}
                    required={true}
                />
                </div>
                </div>
                <div  className="input-group">
                <label> Description</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                <input
                    placeholder='Description'
                    name="description"
                    value={caseSubcat.description}
                    onChange={onSubcatChange}
                    required={true}
                />
                </div>

                </div>
                <div className="select-group">
                <label> Case Catogory <span className="required">*</span> </label>
                <select name="caseCategoryId" value={caseSubcat.caseCategoryId}  onChange={onSubcatChange} >
                    <option value=''>All Category </option>
                    {caseCats.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.categoryTitle}
                    </option>
                    ))}
                </select>
                </div>
                <JisCheckbox value={caseSubcat.isActive} label="Active" onChange={(e)=>setcaseSubcat({...caseSubcat,isActive:e})} />
                <div><JisButton type='submit'>{caseSubcat.id==0?'Save':'Update'}</JisButton></div>
        </form>
                

        </JisDialogForm>} 
       {isDialog && tab=='motiontypes' && <JisDialogForm title="Motion Type" onClose={onClose}>
            <form  onSubmit={onSave}>

                <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={motionType.title}
                    onChange={onMotionTypeChange}
                    required={true}
                  />
                </div>
                </div>
           <div className="select-group">
                <label> Filing Type <span className="required">*</span> </label>
                <select name="filingTypeId" value={motionType.filingTypeId} required={true} onChange={onMotionTypeChange} >
                    <option value="">Select </option>
                    {frequentData.filingtypes?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>  
             <JisCheckbox value={motionType.isActive} label="Active" onChange={(e)=>setMotionType({...motionType,isActive:e})} />
            <div><JisButton type='submit'>{motionType.id==0?'Save':'Update'}</JisButton></div> 

            </form>
            
        </JisDialogForm>} 
       {isDialog && tab=='motionclass' && <JisDialogForm  title="Motion Classification" onClose={onClose}>
            <form  onSubmit={onSave}>

                <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={motionClass.title}
                    onChange={onMotionClassChange}
                    required={true}
                  />
                </div>
                </div>
           <div className="select-group">
                <label> Filing Type <span className="required">*</span> </label>
                <select name="filingTypeId" value={motionClass.filingTypeId} required={true} onChange={onMotionClassChange} >
                    <option value="">Select </option>
                    {frequentData.filingtypes?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>  
             <JisCheckbox value={motionClass.isActive} label="Active" onChange={(e)=>setMotionClass({...motionClass,isActive:e})} />
            <div><JisButton type='submit'>{motionClass.id==0?'Save':'Update'}</JisButton></div> 

            </form>
        </JisDialogForm>} 
        {isDialog && tab=='partytypes' && <JisDialogForm  title="Party Type" onClose={onClose}>
            <form  onSubmit={onSave}>

                <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={partyType.title}
                    onChange={onPartyTypeChange}
                    required={true}
                  />
                </div>
                </div>
            <JisCheckbox value={partyType.isLead} label="Is Lead" onChange={(e)=>setPartyType({...partyType,isLead:e})} />
             <JisCheckbox value={partyType.isActive} label="Active" onChange={(e)=>setPartyType({...partyType,isActive:e})} />
            <div><JisButton type='submit'>{partyType.id==0?'Save':'Update'}</JisButton></div> 

            </form>
        </JisDialogForm>} 
        {isDialog && tab=='casestatuses' && <JisDialogForm  title="Case Status" onClose={onClose}>
            <form  onSubmit={onSave}>

               
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="ttile"
                    value={caseStatus.ttile}
                    onChange={onCaseStatusChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Description</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Description'
                    name="description"
                    value={caseStatus.description}
                    onChange={onCaseStatusChange}
                    required={true}
                  />
                </div>
                </div>
                <div className="select-group">
                <label> Filing Type <span className="required">*</span> </label>
                <select name="filingTypeId" value={caseStatus.filingTypeId} required={true} onChange={onCaseStatusChange} >
                    <option value="">Select </option>
                    {frequentData.filingtypes?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>
                <div  className="input-group">
                <label> SLA Days</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="timeline" />
                  <input
                    placeholder='Sla Days'
                    name="slaDuration"
                    value={caseStatus.slaDuration}
                    type='number'
                    onChange={onCaseStatusChange}
                    required={true}
                  />
                </div>
                </div>
             <JisCheckbox value={caseStatus.isActive} label="Active" onChange={(e)=>setCaseStatus({...caseStatus,isActive:e})} />
            <div><JisButton type='submit'>{caseStatus.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>} 
{isDialog && tab=='expireflow' && <JisDialogForm  title="Expire Case Flow" onClose={onClose}>
            <form  onSubmit={onSave}>

               
            <div  className="input-group">
                <label> Action</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Action Code (Unique)'
                    name="action"
                    value={expireFlow.action}
                    onChange={onExpireFlowChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Description</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Description'
                    name="title"
                    value={expireFlow.title}
                    onChange={onExpireFlowChange}
                    required={true}
                  />
                </div>
                </div>
                <div style={{display:'flex', }}>
                    
                    <div  className="input-group">
                <label> Expire Day</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Day'
                    name="expireDay"
                    value={expireFlow.expireDay}
                    onChange={onExpireFlowChange}
                    required={true}
                    type='number'
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Expire Hour</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Expire Hour'
                    name="expireHr"
                    value={expireFlow.expireHr}
                    onChange={onExpireFlowChange}
                    required={true}
                    type='number'
                  />
                </div>
                </div>

                <div  className="input-group">
                <label> Expire Min</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Expire Hour'
                    name="expireMin"
                    value={expireFlow.expireMin}
                    onChange={onExpireFlowChange}
                    required={true}
                    type='number'
                  />
                </div>
                </div>
                <div  className="input-group">
                    <label> Reminder Day</label>
                    <div className='input-wrapper'>
                    <input
                        placeholder='Expire Hour'
                        name="reminderDay"
                        value={expireFlow.reminderDay}
                        onChange={onExpireFlowChange}
                        required={true}
                        type='number'
                    />
                    </div>
                    </div>
                </div>
             <JisCheckbox value={expireFlow.isActive} label="Active" 
             onChange={(e)=>setExpireFlow({...expireFlow,isActive:e})} />
            <div><JisButton type='submit'>{expireFlow.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>} 
{isDialog && tab=='customcomment' && <JisDialogForm  title="Custom comment" onClose={onClose}>
            <form  onSubmit={onSave}> 
            <div  className="input-group">
                <label> Comment</label>
                <div className='input-wrapper'>
                  <textarea
                    placeholder='Comment'
                    name="comment"
                    value={customComment.comment}
                    onChange={onCustomCommentChange}
                    required={true}
                  ></textarea>
                </div>
                </div>
                
                 <div className="select-group">
                          <label>
                              Role  
                          </label>
                          <select name="roleId" value={customComment.roleId}  onChange={onCustomCommentChange} >
                              <option value="">All </option>
                              {roles.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.name}
                              </option>
                              ))}
                          </select>
                      </div>
             <JisCheckbox value={customComment.isActive} label="Active" 
             onChange={(e)=>setCustomComment({...customComment,isActive:e})} />
            <div><JisButton type='submit'>{customComment.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>}  
{isDialog && tab=='otherpayitem' && <JisDialogForm  title="Other Pay Item" onClose={onClose}>
            <form  onSubmit={onSave}> 
                <div  className="input-group">
                <label> Code</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Code'
                    name="code"
                    value={otherPayItem.code}
                    onChange={onOtherPayItemChange}
                    required={true}
                  />
                </div>
                </div>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Title'
                    name="title"
                    value={otherPayItem.title}
                    onChange={onOtherPayItemChange}
                    required={true}

                  />
                </div>
                </div>
               <div  className="input-group">
                <label> Group Code</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Code Group'
                    name="groupCode"
                    value={otherPayItem.groupCode}
                    onChange={onOtherPayItemChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Fee</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Fee'
                    name="fee"
                    value={otherPayItem.fee}
                    onChange={onOtherPayItemChange}
                    required={true}
                    
                  />
                </div>
                </div>
             <JisCheckbox value={otherPayItem.isActive} label="Active" 
             onChange={(e)=>setOtherPayItem({...otherPayItem,isActive:e})} />
            <div><JisButton type='submit'>{otherPayItem.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>}   
   {isDialog && tab=='specialtemplate' && <JisDialogForm  title="Special Template" onClose={onClose}>
            <form  onSubmit={onSave}> 
                <div  className="input-group">
                <label>Template Id</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Template Id'
                    name="templateId"
                    value={specialTemplate.templateId}
                    onChange={onSpecialTemplateChange}
                    required={true}
                  />
                </div>
                </div>
            <div  className="input-group">
                <label> Code</label>
                <div className='input-wrapper'>
                  <input
                    placeholder='Code'
                    name="code"
                    value={specialTemplate.code}
                    onChange={onSpecialTemplateChange}
                    required={true}

                  />
                </div>
                </div>

            <div><JisButton type='submit'>{specialTemplate.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>}                    
     </div>
     
    </div>
  );
}

export default CaseSettings;